const sampleTasks = require('./sampleWorkflowTasks.json')
const angular = require('angular')
const _ = require('lodash')
import insightsApi from '../../../../modules/insights/api'
import TemplateService from '../../../../services/email/TemplateService';
import * as pulseApi from "../../../../modules/pulse/api"
import sessionStore from '../../../../services/session/SessionStore'
import {REPORTS_BASIC, REPORTS_PREMIUM} from '../../../../modules/insights/listReports/reportsServiceLevelTypes';
import SavedFilterSetFilters, {savedFilterSetBindings, savedFilterSetBindingDefaults} from "../../../../modules/savedFilterSets/SavedFilterSetFilters";
import {getFilterSets} from "../../../../modules/savedFilterSets/savedFilterSetAPI";

angular.module('clientDashboardApp').factory('emailAlertData', function (
  accountsService,
  configService,
  userService,
  providerService,
  $q
) {

  let templateService = new TemplateService();

  const filterSetPromise = getFilterSets({featureGroup: "Pulse"}).then(results => results.map(result => {
    return {
      "label": result["name"],
      "value": result._id.$oid
    }
  }));

  /**
   * Returns a new instance of topic set filter
   * Factory function
   */
  const savedFilters = () => ({
    type: "dropdown",
    name: "savedFilterSet",
    label: "Saved Filter",
    placeholder: "none",
    optionsPromise: filterSetPromise
  })

  let providersToOptions = (results) => results.map(r => ({label: r.name, value: r.id}))
  let providerData = {
    localRankings: providerService.validProviders("all", "LOCAL_RANKING").then(providersToOptions),
    webRankings: providerService.validProviders("all", "WEB_RANKING").then(providersToOptions),
    reviews: providerService.validProviders("all", "REVIEWS").then(providersToOptions),
    media: providerService.validProviders("all", "MEDIA").then(providersToOptions),
    listings: providerService.validProviders("all", "LISTINGS").then(providersToOptions),
    social: providerService.validProviders("all", "CHATTER").then(providersToOptions)
  }

  return configService.getBrandConfig().then((config) => {
    const disabledReportMap = {
      hideReviews: [ 'reviewSummary', 'reviewResponses', 'reviewDetails' ],
      hideListings: [ 'listingSummary' ],
      hideRankings: [ 'rankingSummary' ],
      hideMedia: [ 'media' ],
      hideSentiment: [ 'pulseSummary', 'pulse', 'pulseSummaryWithSunburst' ],
      hideChatter2: [ 'social', 'socialDetails' ],
      hideWorkflow2: ['taskSummaryGadget'],
      hideInsights: ['reportGadget', 'dataSourceGadget']
    }
    const requiredPermissionsMap = {
      reportGadget: 'ShowInsights',
      dataSourceGadget: 'DataExplorerAccess',
    }

    const restrictions = _.reduce(config.restrictions, (disabledReports, isHidden, key) => {
      const exists = _.get(disabledReportMap, key, false)

      return isHidden && exists !== false ? _.concat(disabledReports, exists) : disabledReports
    }, [])

    const filtered =  _.filter(allGadgets(), (gadget) => {
      // Special cases for analytics
      if (gadget.type === 'reportGadget' && sessionStore.reportsService.level === REPORTS_BASIC) {
        return false;
      }
      if (gadget.type === 'dataSourceGadget' && sessionStore.reportsService.level !== REPORTS_PREMIUM) {
        return false;
      }

      const passedRestrictions = !_.includes(restrictions, gadget.type);
      const passedPermissions = !requiredPermissionsMap[gadget.type] || sessionStore.user.permissions.indexOf(requiredPermissionsMap[gadget.type]) !== -1
      return passedRestrictions && passedPermissions
    })

    return {
      realtimeData: {
        GADGETS: filtered.filter(gadget => gadget.type === "reviewDetails") || [],
        SAMPLE_DATA: sampleData()
      },
      data: {
        GADGETS: filtered,
        SAMPLE_DATA: sampleData()
      }
    }
  });

  function allGadgets() {
    return [
        {
          title: "Daily Workflow Tasks",
          type:  "taskSummaryGadget",
          template: templateService.partialByName("tasksGadget"),
          locationSpecific: false,
          filters: [
            {
              label: "Task Categories",
              type: "multiselect",
              name: "taskCategories",
              value: [],
              options: [
                {label: "Custom", value: "Custom"},
                {label: "Reviews", value: "Reviews"},
                {label: "Social", value: "Social"},
                {label: "Listings", value: "Listings"},
                {label: "Media", value: "Media"},
              ]
            },
            {
              label: "Task Assignments",
              type: "multiselect",
              name: "taskAssignments",
              value: [],
              options: [
                {label: "Include Unassigned Tasks", value: "Unassigned"},
                {label: "Include Pending Approval Tasks", value: "PendingApproval"}
              ]
            },
            {
              label: "Include Overdue Tasks",
              heading: "Overdue Tasks",
              type: "checkbox",
              name: "overdueTasks"
            }
          ]
        },
        {
          title: "Analytics Report",
          type:  "reportGadget",
          template: templateService.partialByName("report"),
          locationSpecific: false,
          filters: [
            {
              label: "Report",
              type: "dropdown",
              name: "reportId",
              value: [],
              optionsPromise: insightsApi.getReports().then(response => {
                return response.reports.map(report => ({label: report.name, value: report._id}))
              })
            },
            {
              label: "Tailor to recipients",
              type: "checkbox",
              name: "tailorDataToRecipient",
              description: "Filter report data, showing only what each recipient has access to in the dashboard"
            }
          ]
        },
        {
          title: "Analytics Data Export",
          type:  "dataSourceGadget",
          template: templateService.partialByName("dataSource"),
          locationSpecific: false,
          filters: [
            {
              label: "Report",
              type: "dropdown",
              name: "reportId",
              value: [],
              optionsPromise: insightsApi.getDataSources().then(response => {
                return response.dataSources.map(dataSource => ({label: dataSource.name, value: dataSource._id}))
              })
            }
          ]
        },
        {
          title: "Monthly Review Recap",
          type: "reviewSummary",
          template: templateService.partialByName("reviewSummary"),
          locationSpecific: false,
          disabledScheduleTypes: ['Daily','Weekly'],
          filters: [
            {
              label: "Providers",
              type: "dropdown-multi",
              name: "providers",
              placeholder: "All Providers",
              value: [],
              optionsPromise: providerData.reviews
            }
          ]
        },
        {
          title: "Review Recap",
          type: "reviewRecap",
          template: templateService.partialByName("reviewRecap"),
          locationSpecific: false,
          disabledScheduleTypes: ['Monthly'],
          filtersInheritFrom: 'reviewDetails',
          filters: [
            {
              type: "multiselect",
              mutuallyExclusive: true,
              label: "Text",
              name: "text",
              value: [],
              options: [
                {label: "Only Reviews With Text", value: true},
                {label: "Only Reviews Without Text", value: false}
              ]
            },
            {
              type: "multiselect",
              label: "Only Reviews rated/recommended",
              name: "ratings",
              options: [
                {label: "Doesn't Recommend", value: -2},
                {label: "Recommends", value: -1},
                {label: "1 Star", value: 1},
                {label: "2 Star", value: 2},
                {label: "3 Star", value: 3},
                {label: "4 Star", value: 4},
                {label: "5 Star", value: 5}
              ]
            },
          ]
        },
        {
          title: "Review Responses",
          type: "reviewResponses",
          template: templateService.partialByName("reviewReponses"),
          locationSpecific: true,
          filters: [
            {
              label: "Response Type",
              type: "multiselect",
              mutuallyExclusive: true,
              name: "responseType",
              value: [],
              options: [
                {label: "Owner Responses", value: "FROM_OWNER"},
                {label: "Customer Responses", value: "FROM_CUSTOMER"}
              ]
            }
          ]
        },
        {
          title: "Listing Summary",
          type: "listingSummary",
          template: templateService.partialByName("listingSummary"),
          locationSpecific: false,
          disabledScheduleTypes: ['Daily', 'Weekly'],
          filters: [
            {
              label: "Providers",
              type: "dropdown-multi",
              name: "providers",
              placeholder: "All Providers",
              value: [],
              optionsPromise: providerData.listings
            }
          ]
        },
        {
          title: "Ranking Summary",
          type: "rankingSummary",
          template: templateService.partialByName("rankingSummary"),
          locationSpecific: false,
          disabledScheduleTypes: ['Daily', 'Weekly'],
          filters: [
            {
              label: "Ranking Type",
              type: "multiselect",
              name: "rankingType",
              value: {},
              options: [
                {label: "Local", value: "local"},
                {label: "Web", value: "web"}
              ],
              initialize: (gadget) => {
                let val = {}
                if (_.indexOf(gadget.rankingType, "local") !== -1) {
                  val["Local"] = "local"
                }
                if (_.indexOf(gadget.rankingType, "web") !== -1) {
                  val["Web"] = "web"
                }
                return val
              }
            },
            {
              label: "Report Type",
              type: "multiselect",
              name: "reportType",
              options: [
                {label: "Page 1 Rank Count", value: "page1"},
                {label: "Average Ranks", value: "average"}
              ]
            },
            {
              type: "dropdown-multi",
              label: "Providers", //TODO: label and name are identical at this point
              name: "providers",
              placeholder: "All Providers",
              value: [],
              options: () => {
                return $q.all({web: providerData.webRankings, local: providerData.localRankings}).then(ranks => {
                  return _.sortBy(_.uniqBy(ranks.web.concat(ranks.local), "value"), "label")
                })
              }
            },
          ],
        },
        {
          title: "Pulse Summary",
          type: "pulseSummaryWithSunburst",
          template: templateService.partialByName("pulseSummaryWithSunburst"),
          locationSpecific: false,
          filters: [
            savedFilters(),
          ]
        },
        /* Yay for supporting legacy gadgets */
        {
          title: "Pulse Summary",
          type: "pulseSummary",
          disableFromSelecting: true,
          template: templateService.partialByName("pulseSummary"),
          locationSpecific: false,
          filters: [
            savedFilters(),
          ]
        },
        {
          title: "Review Details",
          type: "reviewDetails",
          template: templateService.partialByName("reviewDetails"),
          locationSpecific: true,
          notes: false,
          filters: [
            {
              type: "multiselect",
              options: [
                { label: "Only Reviews With Responses", value: true },
                { label: "Only Reviews Without Responses", value: false }
              ],
              name: "responses",
              label: "Responses",
              mutuallyExclusive: true
            },
            {
              type: "checkbox",
              label: "Show Notes",
              name: "notes",
              heading: "Notes"
            },
            {
              type: "multiselect",
              mutuallyExclusive: true,
              label: "Text",
              name: "text",
              value: [],
              options: [
                {label: "Only Reviews With Text", value: true},
                {label: "Only Reviews Without Text", value: false}
              ]
            },
/*            {
              type: "boolean",
              label: "Removed Reviews",
              name: "removed",
              options: [
                {label: "Only Removed Reviews", value: false},
              ]
            },*/
            /*{
              type: "multiselect",
              label: "Filtered Reviews",
              name: "filtered",
              options: [
                {label: "Only Filtered Reviews", value: false}
              ]
            },*/
            {
              type: "multiselect",
              label: "Only Reviews rated/recommended",
              name: "ratings",
              options: [
                {label: "Doesn't Recommend", value: -2},
                {label: "Recommends", value: -1},
                {label: "1 Star", value: 1},
                {label: "2 Star", value: 2},
                {label: "3 Star", value: 3},
                {label: "4 Star", value: 4},
                {label: "5 Star", value: 5}
              ]
            },
            {
              type: "checkbox",
              label: "Only Include Revised Reviews",
              name: "withRevisedReviews",
              heading: "Revised Reviews"
            }
          ]
        },
        {
          title: "Pulse",
          type: "pulse",
          template: templateService.partialByName("pulseDetails"),
          locationSpecific: true,
          filters: [
            savedFilters(),
          ]
        },
        {
          title: "Media",
          type: "media",
          template: templateService.partialByName("mediaDetails"),
          locationSpecific: true,
          filters: [
            {
              type: "multiselect",
              label: "Media Filters",
              name: "businessPosted",
              mutuallyExclusive: true,
              options: [
                /*{label: "Starred", value: "starred"},
                 {label: "Positive", value: "positive"},
                 {label: "Negative", value: "negative"},
                 {label: "Has Caption", value: "hasCaption"},*/
                {label: "Only User Posted", value: false},
                {label: "Only Business Posted", value: true}
              ]
            }
          ]
        },
        {
          title: "Social Summary",
          type: "social",
          template: templateService.partialByName("social"),
          locationSpecific: false,
          includeFullAccount: true,
          filters: [
            {
              type: "radio",
              label: "Account",
              name: "accountId",
              options: () => {
                return accountsService.listAccounts().then(res => {
                  return res.accounts.map(account => ({label: account.accountName, value: account.id}))
                })
              }
            },
            {
              type: "checkbox",
              label: "Include whole account",
              name: "includeFullAccount",
              description: "Shows metrics across the whole account, not just specific locations."
            }
          ]
        },
        {
          title: "Social Details",
          type: "socialDetails",
          template: templateService.partialByName("listSocial"),
          locationSpecific: true,
          filters: []
        }
      ].map(gadget => ({...gadget,filters:gadget.filters.map(filter => ({...filter,accessor:{}}))}))
  }
});

function sampleData() {
    return {
        "index": 0,
        "hidePoweredBy": true,
        "resellerLogo": "https://via.placeholder.com/200x100",
        "resellerSubjectLine": "",
        "emailTitle": "Brand Report",
        "emailDate": "11-7-2017",
        "copyrightMsg": "2018",
        "linkUrl": "http://www.anim.com",
        "linkText": "ea elit",
        "emailConfig": {
          "additionalLinks": [
          ],
          emailRestrictions: {
            hidePoweredByLogo : true
          },
          dashboardLink: {
            linkUrl: "http://www.anim.com"
          }
        },
        // insights report gadget
        pdfUrl: "#",
        reportName: "Selected Report",
        // Workflow task summary
        dueTasks: sampleTasks,
        hiddenDueTaskCount: 3,
        showPendingApprovalTasks: true,
        pendingApprovalTasks: sampleTasks,
        hiddenPendingApprovalTaskCount: 5,
        showUnassignedTasks: true,
        unassignedTasks: sampleTasks,
        hiddenUnassignedTaskCount: 19,
        countPastDue: 1,
        countDueToday: 21,
        countPastDuePendingApproval: 3,
        countDueTodayPendingApproval: 4,
        countPastDueUnassigned: 3,
        countDueTodayUnassigned: 4,

        social: {
          totalFollowers: 5,
          newFollowerCount: 5,
          facebookFollowers: 5,
          twitterFollowers: 5,
          instagramFollowers: 4,
          newFacebookFollowers: 1,
          newTwitterFollowers: 2,
          newInstagramFollowers: 2,
          "trendingHashtags": [
            {
              hashtag: "#bhfuewfj",
              frequency: 34
            },
            {
              hashtag: "#ewiurdfns",
              frequency: 17
            },
            {
              hashtag: "#hjrgfjkl",
              frequency: 56
            }
          ],
        },
        pulseSummaryWithSunburst: {
          sunburstChartSrc: "https://s3.amazonaws.com/email-alerts-graphics/v2/highcharts-previews/pulse-sunburst.png",
          distributionChartSrc: "https://s3.amazonaws.com/email-alerts-graphics/v2/highcharts-previews/pulse-distribution.png"
        },
        pulseSummary: {
          totalTopics: 3,
          volumeChartSrc: "https://s3.amazonaws.com/email-alerts-graphics/v2/highcharts-previews/pulse-volume.png",
          distributionChartSrc: "https://s3.amazonaws.com/email-alerts-graphics/v2/highcharts-previews/pulse-distribution.png",
          periodChartSrc: "https://s3.amazonaws.com/email-alerts-graphics/v2/highcharts-previews/pulse-period.png",
        },
        totalListings: 442,
        "listingSummary": [
          {
            provider: "BING",
            found: 23,
            mismatched: 12,
            duplicates: 2
          },
          {
            provider: "FACEBOOK",
            found: 13,
            mismatched: 32,
            duplicates: 4
          },
          {
            provider: "FOURSQUARE",
            found: 14,
            mismatched: 52,
            duplicates: 3
          },
          {
            provider: "GOOGLE",
            found: 34,
            mismatched: 22,
            duplicates: 34
          },
          {
            provider: "YELLOWPAGES",
            found: 24,
            mismatched: 2,
            duplicates: 94
          }
        ],
        rankingSummary: {
          includeAverage:true,
          includePage1:true,
          includeRankings:true,
          includeLocal:true,
          includeWeb:true,
          localRankings: [
            {
              provider: 'FACEBOOK',
              providerName: 'Facebook',
              currentAverage: 5,
              deltaAverage: 2,
              currentPage1: 3,
              deltaPage1: 1
            },
            {
              provider: 'YELP',
              providerName: 'Yelp',
              currentAverage: 4,
              deltaAverage: 3,
              currentPage1: 2,
              deltaPage1: 2
            },
            {
              provider: 'GOOGLE',
              providerName: 'Google',
              currentAverage: 3,
              deltaAverage: 4,
              currentPage1: 1,
              deltaPage1: -2
            }
          ],
          webRankings: [
            {
              provider: 'FACEBOOK',
              providerName: 'Facebook',
              currentAverage: 3,
              deltaAverage: 2,
              currentPage1: 4,
              deltaPage1: 1
            },
            {
              provider: 'YELP',
              providerName: 'Yelp',
              currentAverage: 2,
              deltaAverage: 3,
              currentPage1: 1,
              deltaPage1: 2
            },
            {
              provider: 'GOOGLE',
              providerName: 'Google',
              currentAverage: 2,
              deltaAverage: 4,
              currentPage1: 2,
              deltaPage1: 2
            }
          ]
        },
        reviewRecap: {
          allLocations: {
            totalReviews: 30,
            avgRating: 3.85
          },
          topTenLocations: [{
            "addressSummary": "Hackett, Luettgen and Fisher 69442 Schmedeman Center",
            "totalReviews": 5,
            "avgRating": 4.61
          }, {
            "addressSummary": "Schamberger and Sons 4 Green Plaza",
            "totalReviews": 2,
            "avgRating": 2.38
          }, {
            "addressSummary": "Morissette-Rice 1 Buena Vista Pass",
            "totalReviews": 4,
            "avgRating": 4.56
          }, {
            "addressSummary": "Olson Group 870 Darwin Hill",
            "totalReviews": 2,
            "avgRating": 4.97
          }, {
            "addressSummary": "Green LLC 1277 Pine View Circle",
            "totalReviews": 3,
            "avgRating": 1.36
          }, {
            "addressSummary": "Roberts-Effertz 81 Burrows Crossing",
            "totalReviews": 1,
            "avgRating": 4.3
          }, {
            "addressSummary": "Cruickshank Group 52 Bellgrove Lane",
            "totalReviews": 3,
            "avgRating": 4.93
          }, {
            "addressSummary": "Cruickshank, Jacobs and Yost 53 Scott Place",
            "totalReviews": 5,
            "avgRating": 4.85
          }, {
            "addressSummary": "Schuster-Berge 23916 American Ash Street",
            "totalReviews": 3,
            "avgRating": 2.51
          }, {
            "addressSummary": "Purdy and Sons 0542 Glendale Lane",
            "totalReviews": 5,
            "avgRating": 4.11
          }],
          dashboardLinkUrl: "http://www.anim.com"
        },
        "reviewSummary": {
          period: "LAST 30 DAYS",
          totalPositive: 10,
          totalNeutral: 10,
          totalNegative: 10,
          totalReviews: 14,
          totalResponses:5,
          customerSummary: {
            avgRating: 4.3,
            count: 14,
            countWithResponses: 3,
            oneStarRatings: 4,
            fiveStarRatings: 5
          },
          competitorSummary: {
            avgRating: 4.3,
            count: 14,
            countWithResponses: 3,
            oneStarRatings: 4,
            fiveStarRatings: 5
          },
          customerOverallSummary: {
            avgRating: 4.3,
            count: 14,
            countWithResponses: 3,
            oneStarRatings: 4,
            fiveStarRatings: 5
          },
          competitorOverallSummary: {
            avgRating: 4.3,
            count: 14,
            countWithResponses: 3,
            oneStarRatings: 4,
            fiveStarRatings: 5
          },
          summaryByProvider: [
            {
              provider: "BING",
              customer: {
                count: 3,
                avgRating: 3.6
              },
              competitor: {
                count: 6,
                avgRating: 3.8
              }
            },
            {
              provider: "GOOGLE",
              customer: {
                count: 3,
                avgRating: 3.6
              },
              competitor: {
                count: 14,
                avgRating: 4.2
              }
            }
          ]
        },
        "locations": [
          {
            "location": {
              "storeComparisonReportLink": "http://www.qui.com",
              "businessName": "Red Spoon Burgers",
              "businessAddress": {
                "street": "Glenwood Road",
                "city": "Stewartville",
                "state": "New Hampshire"
              },
              "locationId": "2b3be9fe-5baa-42b8-8018",
              "resellerLocId": "14ba2011-9f4f-43fa-941f-329f3498471b",
              "customMessage": [
                "consequat veniam veniam"
              ]
            },
            "reviews": [
              {
                "_id": "59d7b3d888caf9c9be52949d",
                "locationId": "181fac86-fc64-4e7f-86db-3944a85032fe",
                "resellerLocId": "d9c9f218-2b64-42c0-aac3-f192da08fdac",
                "reviewId": "59d7b3d8fe0d609fca366664",
                "listingId": "77956fcd-7aad-43f4-a39e-4b616b585a71",
                "contentProvider": "FACEBOOK",
                "originalContentProvider": "BING",
                "syndicatedReviews": [],
                "rating": 4,
                "reviewerUserName": "nisi",
                "reviewerPictureURL": "https://via.placeholder.com/60",
                "reviewHeader": "amet sit dolore",
                "reviewDetail": "Tu nulla laboris in elit minim elit aute sit anim sit proident proident ad ut.",
                "reviewURL": "http://www.esse.com",
                "reviewDate": "2011-02-24",
                "dateAdded": "2011-02-24",
                "lastUpdated": "2011-02-24",
                "responses": [],
                "reviewTags": []
              },
              {
                "_id": "59d7b3d888caf9c9be52949d",
                "locationId": "181fac86-fc64-4e7f-86db-3944a85032fe",
                "resellerLocId": "d9c9f218-2b64-42c0-aac3-f192da08fdac",
                "reviewId": "59d7b3d8fe0d609fca366664",
                "listingId": "77956fcd-7aad-43f4-a39e-4b616b585a71",
                "contentProvider": "FACEBOOK",
                "originalContentProvider": "BING",
                "syndicatedReviews": [],
                "isRecommendation":true,
                "recommended": true,
                "recommendedText":"Recommends",
                "reviewerUserName": "nisi",
                "reviewerPictureURL": "https://via.placeholder.com/60",
                "reviewHeader": "amet sit dolore",
                "reviewDetail": "This is a sample recommendation.",
                "reviewURL": "http://www.esse.com",
                "reviewDate": "2011-02-24",
                "dateAdded": "2011-02-24",
                "lastUpdated": "2011-02-24",
                "responses": [],
                "reviewTags": []
              },
              {
                "_id": "59d7b3d831619df9eed41bc5",
                "locationId": "82c04dc8-5081-43d9-932d-5d5209ca4483",
                "resellerLocId": "2fe309a0-cb26-4995-a1b6-5dfc387e5d41",
                "reviewId": "59d7b3d89eb0cc7d3e1c18cf",
                "listingId": "129505cb-ecab-48df-9714-a6fc6bec9fc2",
                "contentProvider": "YELP",
                "originalContentProvider": "YELP",
                "syndicatedReviews": [],
                "rating": 3,
                "reviewerUserName": "cupidatat",
                "email": "test5@yahoo.com",
                "reviewerPictureURL": "https://via.placeholder.com/60",
                "reviewHeader": "ad reprehenderit enim",
                "reviewDetail": "Aliqua id fugiat mollit nisi velit consequat magna elit.",
                "reviewURL": "http://www.ut.com",
                "reviewDate": "2011-02-24",
                "dateAdded": "2011-02-24",
                "lastUpdated": "2011-02-24",
                "responses": [],
                "reviewTags": []
              },
              {
                "_id": "59d7b3d832f7807616aee4e8",
                "locationId": "212b317d-8cea-41d8-ad18-a5e6f23812e2",
                "resellerLocId": "e65ff5be-b4e2-4302-bc7f-3d139b3c7d12",
                "reviewId": "59d7b3d839f0cd4414f36587",
                "listingId": "97384a37-96bf-4506-baad-c0193dc2a6a7",
                "contentProvider": "FACEBOOK",
                "originalContentProvider": "BING",
                "syndicatedReviews": [],
                "rating": 2,
                "reviewerUserName": "cupidatat",
                "email": "test2@gmail.com",
                "phone": "619-795-6262",
                "reviewerPictureURL": "https://via.placeholder.com/60",
                "reviewHeader": "exercitation excepteur officia",
                "reviewDetail": "In amet enim adipisicing elit consectetur.",
                "reviewURL": "http://www.non.com",
                "reviewDate": "2011-02-24",
                "dateAdded": "2011-02-24",
                "lastUpdated": "2011-02-24",
                "responses": [],
                "reviewTags": []
              }],
          "reviewTotal": 4,
          "responseTotal": 0,
          "totalPositive": 1,
          "totalNeutral": 1,
          "totalNegative": 1,
          "pulseDetails": {
            "totalSegments": 3,
            "totalPositive": 1,
            "totalNeutral": 1,
            "totalNegative": 1,
            "segmentsByClassification": [
              {
                "type": "Neutral",
                "segments": [
                  {
                    "_id": "57f2d5b066d482cf974e2bca",
                    "locationId": "legacy-502517",
                    "reviewId": "57f1ed9b57942a8c0bdb942d",
                    "provider": "YELP",
                    "segment": "I asked for a cup of tap water to go with it.",
                    "classification": "Neutral",
                    "polarity": 2,
                    "reviewDate": "2016-09-25",
                    "topics": [
                      "cup",
                      "tap",
                      "water"
                    ],
                    "billingAccountId": "5792afcfd4c6c755215ca8a7",
                    "primaryListing": true,
                    "isSyndicated": false,
                    "accountId": "56fd68d6ccd4706ccae8e6d4",
                    "businessName": "Auntie Anne's",
                    "locationPrimaryCategory": "Fast Food",
                    "reviewSentenceCount": 11
                  }
                ]
              },
              {
                "type": "Negative",
                "segments": [
                  {
                    "_id": "57f2d5b066d482cf974e2bcb",
                    "locationId": "legacy-502517",
                    "reviewId": "57f1ed9b57942a8c0bdb942d",
                    "contentProvider": "YELP",
                    "segment": "I was told that he could either sell me a bottle of water or I could pay for a cup with ice and then go find water somewhere else-he wouldn't even put water in the cup if it was paid for.",
                    "classification": "Negative",
                    "polarity": 1,
                    "reviewDate": "2016-09-25",
                    "topics": [
                      "bottle",
                      "water",
                      "cup",
                      "ice",
                      "water",
                      "water",
                      "cup"
                    ],
                    "billingAccountId": "5792afcfd4c6c755215ca8a7",
                    "primaryListing": true,
                    "isSyndicated": false,
                    "accountId": "56fd68d6ccd4706ccae8e6d4",
                    "businessName": "Auntie Anne's",
                    "locationPrimaryCategory": "Fast Food",
                    "reviewSentenceCount": 11
                  }
                ]
              },
              {
                "type": "Positive",
                "segments": [
                  {
                    "_id": "57f2d5b066d482cf974e2bc9",
                    "locationId": "legacy-502517",
                    "reviewId": "57f1ed9b57942a8c0bdb942d",
                    "contentProvider": "YELP",
                    "segment": "The best pretzels I have ever had!",
                    "classification": "Positive",
                    "polarity": 3,
                    "reviewDate": "2016-09-25",
                    "topics": [
                      "mall",
                      "today",
                      "cup"
                    ],
                    "billingAccountId": "5792afcfd4c6c755215ca8a7",
                    "primaryListing": true,
                    "isSyndicated": false,
                    "accountId": "56fd68d6ccd4706ccae8e6d4",
                    "businessName": "Auntie Anne's",
                    "locationPrimaryCategory": "Fast Food",
                    "reviewSentenceCount": 11
                  },
                ]
              }
            ]
          },
          media: [
            {
              "_id": "5670bfbde0a421fd1312a2e1",
              "contentProvider": "BING",
              "source": {
                "_id": "1334",
                "sourceType": "Listing"
              },
              "url": "http://www.bing.com/th?id=A%252bGYXmmw3XjT8RA480x360&6w=80&6h=80&6c=2&6pid=local",
              "locationId": "legacy-7",
              "mediaType": "Image",
              "datePosted": "2015-12-16T01:37:25.544Z",
              "dateAdded": "2015-12-16T01:37:25.544Z",
              "isRemoved": false,
              "hidden": false,
              caption: "doler ipsur quanticus besmercher levantus traulsy plantiverticus."
            },
            {
              "_id": "5670bfbde0a421fd1312a2f3",
              "contentProvider": "BING",
              "source": {
                "_id": "1251",
                "sourceType": "Listing"
              },
              "url": "http://www.bing.com/th?id=Aqj4se9NekRASsQ480x360&6w=80&6h=80&6c=2&6pid=local",
              "locationId": "legacy-10",
              "mediaType": "Image",
              "datePosted": "2015-12-16T01:37:25.546Z",
              "dateAdded": "2015-12-16T01:37:25.546Z",
              "isRemoved": false,
              "hidden": false
            },
            {
              "_id": "5670bfbde0a421fd1312a2e9",
              "contentProvider": "BING",
              "source": {
                "_id": "2485",
                "sourceType": "Listing"
              },
              "url": "http://images.citysearch.net/assets/imgdb/merchant/2010/10/14/0/aBUOFCaT161.jpeg",
              "locationId": "legacy-20",
              "mediaType": "Image",
              "datePosted": "2015-12-16T01:37:25.545Z",
              "dateAdded": "2015-12-16T01:37:25.545Z",
              "isRemoved": false,
              "hidden": false
            }
          ],
          "social": {
            "mentions": [
              {
                "_id": "587e67980100002100a92d31",
                "details": {
                  "id": "tag:search.twitter.com,2005:821155151800975360",
                  "text": "@testeralex86 another Happy Mondayea2bafc2-98cd-408d-8b25-d480f22c72642d0b78f6-63b1-4ffc-a351-f84f630fb5a1 26 123 77 152 122 96 26 195",
                  "isRepost": false,
                  "username": "testeralex86",
                  "displayName": "Alex Test",
                  "createdTime": 1484613619000,
                  "avatarUrl": "https://abs.twimg.com/sticky/default_profile_images/default_profile_3_normal.png",
                  "originalLink": "http://twitter.com/testeralex86/statuses/821155151800975360",
                  "attachments": [],
                  "raw": {}
                },
                "context": {
                  "accountId": "56a184a6d4c61f5267b3f386",
                  "_deleted": 1501106146887,
                  "sources": [],
                  "provider": "Twitter",
                  "sourceTags": [],
                  "dateAdded": 1484767905698
                },
                "matchFields": {
                  "mentions": [
                    "testeralex86",
                    "alex test"
                  ],
                  "hashtags": []
                },
                "userProvidedData": {
                  "noteIds": []
                },
                "sentiment": {
                  "sentences": [
                    {
                      "segment": "@testeralex86 another Happy Monday",
                      "sentimentClassification": "Positive",
                      "topics": []
                    }
                  ],
                  "sentimentClassification": "Positive"
                }
              }
              ,
              {
                "_id": "587e67980100001d00a92d32",
                "details": {
                  "id": "tag:search.twitter.com,2005:821408535170846720",
                  "text": "@testeralex86 Good Morning, Alex! Happy Tuesday!!! 26 123 76 152 122 96 26 195",
                  "isRepost": false,
                  "username": "testeralex86",
                  "displayName": "Alex Test",
                  "createdTime": 1484674030000,
                  "avatarUrl": "https://abs.twimg.com/sticky/default_profile_images/default_profile_3_normal.png",
                  "originalLink": "http://twitter.com/testeralex86/statuses/821408535170846720",
                  "attachments": [],
                  "raw": {}
                },
                "context": {
                  "accountId": "56a184a6d4c61f5267b3f386",
                  "_deleted": 1501106146887,
                  "sources": [],
                  "provider": "Twitter",
                  "sourceTags": [],
                  "dateAdded": 1484767905697
                },
                "matchFields": {
                  "mentions": [
                    "testeralex86",
                    "alex test"
                  ],
                  "hashtags": []
                },
                "userProvidedData": {
                  "noteIds": []
                },
                "sentiment": {
                  "sentences": [
                    {
                      "segment": "@testeralex86 Good Morning, Alex!",
                      "sentimentClassification": "Positive",
                      "topics": []
                    },
                    {
                      "segment": "Happy Tuesday!!!",
                      "sentimentClassification": "Positive",
                      "topics": []
                    }
                  ],
                  "sentimentClassification": "Positive"
                }
              },
              {
                "_id": "587979f71000001d0027c17f",
                "details": {
                  "id": "tag:search.twitter.com,2005:819688039534497793",
                  "text": "@BaconJake https://t.co/VoVybE4QYZ",
                  "username": "BaconJake",
                  "displayName": "Bacon Jake",
                  "createdTime": 1484263832000,
                  "avatarUrl": "https://via.placeholder.com/60",
                  "originalLink": "http://twitter.com/BaconJake/statuses/819688039534497793",
                  "attachments": [
                    {
                      "id": "819688024510439426",
                      "url": "https://pbs.twimg.com/tweet_video_thumb/C2Ad6leWIAIInNc.jpg",
                      "attachmentType": "Image"
                    }
                  ],
                  "raw": {
                    "id": "tag:search.twitter.com,2005:819688039534497793",
                    "objectType": "activity",
                    "verb": "post",
                    "postedTime": "2017-01-12T23:30:32.000Z",
                    "generator": {
                      "displayName": "Twitter Web Client",
                      "link": "http://twitter.com"
                    },
                    "provider": {
                      "objectType": "service",
                      "displayName": "Twitter",
                      "link": "http://www.twitter.com"
                    },
                    "link": "http://twitter.com/BaconJake/statuses/819688039534497793",
                    "body": "@BaconJake https://t.co/VoVybE4QYZ",
                    "display_text_range": [
                      0,
                      16
                    ],
                    "actor": {
                      "objectType": "person",
                      "id": "id:twitter.com:808441805943537664",
                      "link": "http://www.twitter.com/BaconJake",
                      "displayName": "Bacon Jake",
                      "postedTime": "2016-12-12T22:42:01.467Z",
                      "image": "https://pbs.twimg.com/profile_images/816785256430768128/e4HTWoYn_normal.jpg",
                      "summary": null,
                      "friendsCount": 0,
                      "followersCount": 0,
                      "listedCount": 0,
                      "statusesCount": 77,
                      "twitterTimeZone": null,
                      "verified": false,
                      "utcOffset": null,
                      "preferredUsername": "BaconJake",
                      "languages": [
                        "en"
                      ],
                      "links": [
                        {
                          "href": null,
                          "rel": "me"
                        }
                      ],
                      "location": {
                        "objectType": "place",
                        "displayName": "San Diego, CA"
                      },
                      "favoritesCount": 0
                    },
                    "object": {
                      "objectType": "note",
                      "id": "object:search.twitter.com,2005:819688039534497793",
                      "summary": "@BaconJake https://t.co/VoVybE4QYZ",
                      "link": "http://twitter.com/BaconJake/statuses/819688039534497793",
                      "postedTime": "2017-01-12T23:30:32.000Z"
                    },
                    "favoritesCount": 0,
                    "twitter_entities": {
                      "hashtags": [],
                      "urls": [],
                      "user_mentions": [
                        {
                          "screen_name": "BaconJake",
                          "name": "Bacon Jake",
                          "id": 808441805943537664,
                          "id_str": "808441805943537664",
                          "indices": [
                            0,
                            16
                          ]
                        }
                      ],
                      "symbols": [],
                      "media": [
                        {
                          "id": 819688024510439426,
                          "id_str": "819688024510439426",
                          "indices": [
                            17,
                            40
                          ],
                          "media_url": "http://www.placebear.com/200/300",
                          "media_url_https": "https://pbs.twimg.com/tweet_video_thumb/C2Ad6leWIAIInNc.jpg",
                          "url": "https://t.co/VoVybE4QYZ",
                          "display_url": "pic.twitter.com/VoVybE4QYZ",
                          "expanded_url": "https://twitter.com/BaconJake/status/819688039534497793/photo/1",
                          "type": "photo",
                          "sizes": {
                            "small": {
                              "w": 340,
                              "h": 340,
                              "resize": "fit"
                            },
                            "thumb": {
                              "w": 150,
                              "h": 150,
                              "resize": "crop"
                            },
                            "large": {
                              "w": 400,
                              "h": 400,
                              "resize": "fit"
                            },
                            "medium": {
                              "w": 400,
                              "h": 400,
                              "resize": "fit"
                            }
                          }
                        }
                      ]
                    },
                    "twitter_extended_entities": {
                      "media": [
                        {
                          "id": 819688024510439426,
                          "id_str": "819688024510439426",
                          "indices": [
                            17,
                            40
                          ],
                          "media_url": "http://www.placebear.com/200/300",
                          "media_url_https": "https://pbs.twimg.com/tweet_video_thumb/C2Ad6leWIAIInNc.jpg",
                          "url": "https://t.co/VoVybE4QYZ",
                          "display_url": "pic.twitter.com/VoVybE4QYZ",
                          "expanded_url": "https://twitter.com/BaconJake/status/819688039534497793/photo/1",
                          "type": "animated_gif",
                          "sizes": {
                            "small": {
                              "w": 340,
                              "h": 340,
                              "resize": "fit"
                            },
                            "thumb": {
                              "w": 150,
                              "h": 150,
                              "resize": "crop"
                            },
                            "large": {
                              "w": 400,
                              "h": 400,
                              "resize": "fit"
                            },
                            "medium": {
                              "w": 400,
                              "h": 400,
                              "resize": "fit"
                            }
                          },
                          "video_info": {
                            "aspect_ratio": [
                              1,
                              1
                            ],
                            "variants": [
                              {
                                "bitrate": 0,
                                "content_type": "video/mp4",
                                "url": "https://video.twimg.com/tweet_video/C2Ad6leWIAIInNc.mp4"
                              }
                            ]
                          }
                        }
                      ]
                    },
                    "twitter_lang": "und",
                    "retweetCount": 0,
                    "gnip": {
                      "matching_rules": [
                        {
                          "value": "@BaconJake",
                          "tag": null
                        }
                      ]
                    },
                    "twitter_filter_level": "low"
                  }
                },
                "context": {
                  "accountId": "56a184a6d4c61f5267b3f386",
                  "chatterUserAccountId": "587979d54c00002b01ea1e05",
                  "locationIds": [],
                  "provider": "Twitter",
                  "dateAdded": 1484356087851
                },
                "matchFields": {
                  "mentions": [
                    "BaconJake",
                    "Bacon Jake"
                  ],
                  "hashtags": []
                },
                "userProvidedData": {
                  "noteIds": []
                },
                "sentiment": {
                  "sentences": [
                    {
                      "segment": "@BaconJake https://t.co/VoVybE4QYZ",
                      "sentimentClassification": "Neutral",
                      "topics": []
                    }
                  ],
                  "sentimentClassification": "Neutral"
                }
              },

              {
                "_id": "5942e2692400001900dceb12",
                "details": {
                  "id": "205402409499516_1480595688646842",
                  "text": "#Howdy! Ride on thru for a Burger. Our team is ready #Hodads",
                  "isRepost": false,
                  "likes": 18,
                  "authorId": "205402409499516",
                  "displayName": "Hodad's San Diego",
                  "createdTime": 1497207270000,
                  "avatarUrl": "https://graph.facebook.com/205402409499516/picture",
                  "originalLink": "https://www.facebook.com/205402409499516_1480595688646842",
                  "geo": {
                    "type": "Point",
                    "coordinates": [
                      -117.251213,
                      32.7471859
                    ]
                  },
                  "raw": {
                    "type": "video",
                    "message": "#Howdy! Ride on thru for a Burger. Our team is ready #Hodads",
                    "status_type": "added_video",
                    "from": {
                      "name": "Hodad's San Diego",
                      "id": "205402409499516"
                    },
                    "created_time": "2017-06-11T18:54:30+0000",
                    "link": "https://www.facebook.com/Hodads1904/videos/1480595688646842/",
                    "full_picture": "https://scontent.xx.fbcdn.net/v/t15.0-10/19145029_1480596048646806_2242229252160225280_n.jpg?oh=90048b05464e7472314c032a19662e40&oe=5A77D66C",
                    "id": "205402409499516_1480595688646842",
                    "likes": {
                      "data": [],
                      "summary": {
                        "total_count": 18,
                        "can_like": false,
                        "has_liked": false
                      }
                    },
                    "comments": {
                      "data": [
                        {
                          "created_time": "2017-06-11T19:09:04+0000",
                          "from": {
                            "name": "Laura N Rene",
                            "id": "715415392000537"
                          },
                          "id": "1480595688646842_1480605898645821",
                          "attachment": {
                            "media": {
                              "image": {
                                "height": 600,
                                "src": "https://scontent.xx.fbcdn.net/v/t39.1997-6/851575_126362067548590_1152922410_n.png?oh=1903be50c1797a85da04a6f66e95434a&oe=5A441F60",
                                "width": 600
                              }
                            },
                            "target": {
                              "id": "126362064215257",
                              "url": "https://scontent.xx.fbcdn.net/v/t39.1997-6/851575_126362067548590_1152922410_n.png?oh=1903be50c1797a85da04a6f66e95434a&oe=5A441F60"
                            },
                            "type": "sticker",
                            "url": "https://scontent.xx.fbcdn.net/v/t39.1997-6/851575_126362067548590_1152922410_n.png?oh=1903be50c1797a85da04a6f66e95434a&oe=5A441F60"
                          },
                          "message": "",
                          "likes": {
                            "data": [],
                            "summary": {
                              "total_count": 0,
                              "can_like": false,
                              "has_liked": false
                            }
                          },
                          "comments": {
                            "data": [],
                            "summary": {
                              "order": "chronological",
                              "total_count": 0,
                              "can_comment": false
                            }
                          }
                        },
                        {
                          "created_time": "2017-06-11T19:09:39+0000",
                          "from": {
                            "name": "Laura N Rene",
                            "id": "715415392000537"
                          },
                          "id": "1480595688646842_1480606218645789",
                          "message": "Compadres amigos quien se anima en la tarde Armando Velasquez Vicky Luna Moises Cruz Vladimir Camacho Citlaly Ramirez",
                          "likes": {
                            "data": [],
                            "summary": {
                              "total_count": 0,
                              "can_like": false,
                              "has_liked": false
                            }
                          },
                          "comments": {
                            "data": [
                              {
                                "created_time": "2017-06-11T19:41:56+0000",
                                "from": {
                                  "name": "Vicky Luna",
                                  "id": "1572800472744311"
                                },
                                "id": "1480595688646842_1480631075309970",
                                "message": "Vamos a habit",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:49:30+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480636798642731",
                                "message": "Vicky Luna no hoddas",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:50:09+0000",
                                "from": {
                                  "name": "Moises Cruz",
                                  "id": "1432407226797503"
                                },
                                "id": "1480595688646842_1480637078642703",
                                "message": "Vamos. A habit",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 2,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:50:17+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480637181976026",
                                "message": "Si amor ❤️ mejor vamos a habit yo boy contigo amor",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:50:19+0000",
                                "from": {
                                  "name": "Moises Cruz",
                                  "id": "1432407226797503"
                                },
                                "id": "1480595688646842_1480637208642690",
                                "message": "No hodan",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:50:38+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480637325309345",
                                "message": "Armando Velasquez si mi amor vamos al habit",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:51:01+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480637471975997",
                                "message": "No mas porque tu me lo pides",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:51:02+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480637495309328",
                                "message": "Somos 3 a 1 así que ganó habit",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 2,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:51:22+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480637621975982",
                                "message": "Ahahahahah",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:51:35+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480637721975972",
                                "message": "Van a venir a misa",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:51:52+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480637861975958",
                                "message": "Apenas se acabo la misa de las 11",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:52:29+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480638205309257",
                                "message": "Es el último día de padre muro se va a acabar a las 3 hoy 😰😫",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 2,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:58:58+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480642338642177",
                                "message": "Si ya que se acabe para despedir al padre muro",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-11T19:58:59+0000",
                                "from": {
                                  "name": "Moises Cruz",
                                  "id": "1432407226797503"
                                },
                                "id": "1480595688646842_1480642355308842",
                                "message": "Ay cosita.",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:22:40+0000",
                                "from": {
                                  "name": "Citlaly Ramirez",
                                  "id": "1458665404228361"
                                },
                                "id": "1480595688646842_1480906628615748",
                                "message": "Buenos y aquihoras vamos a ir a habit pues",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 2,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:26:16+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480908588615552",
                                "message": "Citlaly Ramirez vamos encuanto se acabe el juego de mexico vs usa",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:27:27+0000",
                                "from": {
                                  "name": "Citlaly Ramirez",
                                  "id": "1458665404228361"
                                },
                                "id": "1480595688646842_1480909141948830",
                                "message": "Me avisan entonces",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 2,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:27:51+0000",
                                "from": {
                                  "name": "Citlaly Ramirez",
                                  "id": "1458665404228361"
                                },
                                "id": "1480595688646842_1480909301948814",
                                "message": "🍽",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:28:15+0000",
                                "from": {
                                  "name": "Citlaly Ramirez",
                                  "id": "1458665404228361"
                                },
                                "id": "1480595688646842_1480909478615463",
                                "message": "Solos a con todos",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:32:37+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480911661948578",
                                "message": "Todos en bola compadre Armando Velasquez o nomas adultos",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:40:03+0000",
                                "from": {
                                  "name": "Armando Velasquez",
                                  "id": "1371946709593690"
                                },
                                "id": "1480595688646842_1480916755281402",
                                "message": "Nomas adultos",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:51:02+0000",
                                "from": {
                                  "name": "Citlaly Ramirez",
                                  "id": "1458665404228361"
                                },
                                "id": "1480595688646842_1480923858614025",
                                "message": "Ok",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 1,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:52:53+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480925261947218",
                                "message": "Citlaly Ramirez no mejor con los niños",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              },
                              {
                                "created_time": "2017-06-12T01:54:27+0000",
                                "from": {
                                  "name": "Citlaly Ramirez",
                                  "id": "1458665404228361"
                                },
                                "id": "1480595688646842_1480926215280456",
                                "message": "Laura N Rene  a ok",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              }
                            ],
                            "paging": {
                              "cursors": {
                                "before": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURZAek1UQTNOVE13T1RrM01Eb3hORGszTWpFd01URTIZD",
                                "after": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURreU5qSXhOVEk0TURRMU5qb3hORGszTWpNeU5EWTMZD"
                              }
                            },
                            "summary": {
                              "order": "chronological",
                              "total_count": 24,
                              "can_comment": false
                            }
                          }
                        },
                        {
                          "created_time": "2017-06-11T19:10:29+0000",
                          "from": {
                            "name": "Armando Velasquez",
                            "id": "1371946709593690"
                          },
                          "id": "1480595688646842_1480607238645687",
                          "message": "Si vamos",
                          "likes": {
                            "data": [],
                            "summary": {
                              "total_count": 1,
                              "can_like": false,
                              "has_liked": false
                            }
                          },
                          "comments": {
                            "data": [
                              {
                                "created_time": "2017-06-11T19:10:45+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480607575312320",
                                "message": "Arre mijo ya dijo",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              }
                            ],
                            "paging": {
                              "cursors": {
                                "before": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURZAd056VTNOVE14TWpNeU1Eb3hORGszTWpBNE1qUTEZD",
                                "after": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURZAd056VTNOVE14TWpNeU1Eb3hORGszTWpBNE1qUTEZD"
                              }
                            },
                            "summary": {
                              "order": "chronological",
                              "total_count": 1,
                              "can_comment": false
                            }
                          }
                        },
                        {
                          "created_time": "2017-06-11T19:10:43+0000",
                          "from": {
                            "name": "Armando Velasquez",
                            "id": "1371946709593690"
                          },
                          "id": "1480595688646842_1480607555312322",
                          "message": "Apenas voy en camino a misa",
                          "likes": {
                            "data": [],
                            "summary": {
                              "total_count": 1,
                              "can_like": false,
                              "has_liked": false
                            }
                          },
                          "comments": {
                            "data": [
                              {
                                "created_time": "2017-06-11T19:11:01+0000",
                                "from": {
                                  "name": "Laura N Rene",
                                  "id": "715415392000537"
                                },
                                "id": "1480595688646842_1480607875312290",
                                "message": "Ya vamos de regreso",
                                "likes": {
                                  "data": [],
                                  "summary": {
                                    "total_count": 0,
                                    "can_like": false,
                                    "has_liked": false
                                  }
                                }
                              }
                            ],
                            "paging": {
                              "cursors": {
                                "before": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURZAd056ZAzNOVE14TWpJNU1Eb3hORGszTWpBNE1qWXgZD",
                                "after": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURZAd056ZAzNOVE14TWpJNU1Eb3hORGszTWpBNE1qWXgZD"
                              }
                            },
                            "summary": {
                              "order": "chronological",
                              "total_count": 1,
                              "can_comment": false
                            }
                          }
                        },
                        {
                          "created_time": "2017-06-11T19:29:32+0000",
                          "from": {
                            "name": "Rhonda May",
                            "id": "10209517905368563"
                          },
                          "id": "1480595688646842_1480622188644192",
                          "message": "Hodad's!! I visited in January.  I got a sticker!  That thing is still on my t shirt!! Great place. Great sticker!!!",
                          "likes": {
                            "data": [],
                            "summary": {
                              "total_count": 1,
                              "can_like": false,
                              "has_liked": false
                            }
                          },
                          "comments": {
                            "data": [],
                            "summary": {
                              "order": "chronological",
                              "total_count": 0,
                              "can_comment": false
                            }
                          }
                        },
                        {
                          "created_time": "2017-06-12T00:00:15+0000",
                          "from": {
                            "name": "Ken Deitreich",
                            "id": "1478914132154722"
                          },
                          "id": "1480595688646842_1480852598621151",
                          "message": "Robert Helsel",
                          "likes": {
                            "data": [],
                            "summary": {
                              "total_count": 0,
                              "can_like": false,
                              "has_liked": false
                            }
                          },
                          "comments": {
                            "data": [],
                            "summary": {
                              "order": "chronological",
                              "total_count": 0,
                              "can_comment": false
                            }
                          }
                        }
                      ],
                      "paging": {
                        "cursors": {
                          "before": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURZAd05UZAzVPRFkwTlRneU1Ub3hORGszTWpBNE1UUTEZD",
                          "after": "WTI5dGJXVnVkRjlqZAFhKemIzSTZANVFE0TURnMU1qVTVPRFl5TVRFMU1Ub3hORGszTWpJMU5qRTEZD"
                        }
                      },
                      "summary": {
                        "order": "chronological",
                        "total_count": 6,
                        "can_comment": false
                      }
                    }
                  }
                },
                "context": {
                  "accountId": "56a184a6d4c61f5267b3f386",
                  "sources": [
                    {
                      "type": "Location",
                      "id": "100000046"
                    },
                    {
                      "type": "Listing",
                      "id": "100119489"
                    },
                    {
                      "type": "RemotePageId",
                      "id": "205402409499516"
                    }
                  ],
                  "provider": "Facebook",
                  "sourceTags": [
                    "Page",
                    "Self"
                  ],
                  "dateAdded": 1502423294940
                },
                "conversation": {
                  "scrapedAncestorIds": [],
                  "ancestorIds": [],
                  "hasReplies": true,
                  "ancestorsIdsAscending": []
                },
                "matchFields": {
                  "mentions": [
                    "hodad's san diego"
                  ],
                  "hashtags": [
                    "howdy",
                    "hodads"
                  ]
                },
                "userProvidedData": {
                  "noteIds": []
                },
                "sentiment": {
                  "sentences": [
                    {
                      "segment": "#Howdy!",
                      "sentimentClassification": "Neutral",
                      "topics": []
                    },
                    {
                      "segment": "Ride on thru for a Burger.",
                      "sentimentClassification": "Negative",
                      "topics": []
                    },
                    {
                      "segment": "Our team is ready #Hodads",
                      "sentimentClassification": "Neutral",
                      "topics": [
                        {
                          "segment": "team",
                          "sentimentClassification": "Neutral"
                        }
                      ]
                    }
                  ],
                  "sentimentClassification": "Negative"
                }
              },
              {
                "_id": "587fc2a20100001e00927d57",
                "details": {
                  "id": "tag:search.twitter.com,2005:821762091702829056",
                  "text": "@testeralex86 Happy Wednesday! 26 123 77 152 122 96 26 195",
                  "isRepost": false,
                  "username": "testeralex86",
                  "displayName": "Alex Test",
                  "createdTime": 1484758324000,
                  "avatarUrl": "https://abs.twimg.com/sticky/default_profile_images/default_profile_3_normal.png",
                  "originalLink": "http://twitter.com/testeralex86/statuses/821762091702829056",
                  "attachments": [],
                  "raw": {}
                },
                "context": {
                  "accountId": "56a184a6d4c61f5267b3f386",
                  "_deleted": 1501106146887,
                  "sources": [],
                  "provider": "Twitter",
                  "sourceTags": [],
                  "dateAdded": 1484767906930
                },
                "matchFields": {
                  "mentions": [
                    "testeralex86",
                    "alex test"
                  ],
                  "hashtags": []
                },
                "userProvidedData": {
                  "noteIds": []
                },
                "sentiment": {
                  "sentences": [
                    {
                      "segment": "@testeralex86 Happy Wednesday!",
                      "sentimentClassification": "Positive",
                      "topics": []
                    }
                  ],
                  "sentimentClassification": "Positive"
                }
              },
              {
                "_id": "587fc2a20100001f00927d58",
                "details": {
                  "id": "tag:search.twitter.com,2005:821517305146281984",
                  "text": "@testeralex86 almost done for today! 20 mins 26 123 77 152 122 96 26 195",
                  "isRepost": false,
                  "username": "testeralex86",
                  "displayName": "Alex Test",
                  "createdTime": 1484699963000,
                  "avatarUrl": "https://abs.twimg.com/sticky/default_profile_images/default_profile_3_normal.png",
                  "originalLink": "http://twitter.com/testeralex86/statuses/821517305146281984",
                  "attachments": [],
                  "raw": {}
                },
                "context": {
                  "accountId": "56a184a6d4c61f5267b3f386",
                  "_deleted": 1501106146888,
                  "sources": [],
                  "provider": "Twitter",
                  "sourceTags": [],
                  "dateAdded": 1484767906940
                },
                "matchFields": {
                  "mentions": [
                    "testeralex86",
                    "alex test"
                  ],
                  "hashtags": []
                },
                "userProvidedData": {
                  "noteIds": []
                },
                "sentiment": {
                  "sentences": [
                    {
                      "segment": "@testeralex86 almost done for today!",
                      "sentimentClassification": "Positive",
                      "topics": [
                        {
                          "segment": "@testeralex86",
                          "sentimentClassification": "Positive"
                        }
                      ]
                    },
                    {
                      "segment": "20 mins",
                      "sentimentClassification": "Neutral",
                      "topics": []
                    }
                  ],
                  "sentimentClassification": "Neutral"
                }
              }
            ]

          }
        }
      ]
    }
}
